import { put } from "redux-saga/effects";
import { SessionStorage } from "../../lib";
import { Creators } from ".";

export default function* getGlobalStatus({ userData }) {
  const isLoggedIn = SessionStorage.getItem("isLoggedIn");
  if (isLoggedIn) {
    if (!Boolean(userData)) {
      yield put(Creators.getUserInfos());
    }

    yield put(Creators.setIsLoggedIn(true));
  }
}
